import { SxProps, Theme } from "@mui/material";

import {
  tableContainerSx,
  tableScrollAreaSx,
  tableWrapperSx,
} from "./ActivitiesTable/ActivitiesTable.styles";

export const modalContainerSx: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100vw",
  height: "100vh",
  bgcolor: "background.paper",
  borderRadius: 0,
  p: 2,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const modalHeaderSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 1.25,
  flexShrink: 0,
};

/** Scrollport below header; wraps fields, filters, activities, and submit */
export const modalFormSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

/** Compact close control (avoid global `.button` which forces 45px height) */
export const modalCloseIconButtonSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  p: 0,
  borderRadius: "8px",
  bgcolor: "common.black",
  color: "common.white",
  "&:hover": { bgcolor: "grey.800" },
};

export const modalCloseGlyphSx: SxProps<Theme> = {
  fontSize: 18,
};

export const modalTitleSx: SxProps<Theme> = {
  fontWeight: 700,
};

/** Table + selected activities; sizes to content inside form scrollport */
export const modalMainColumnSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
};

export const callPlanModalTableWrapperSx: SxProps<Theme> = {
  ...tableWrapperSx,
  flex: "none",
};

const CALL_PLAN_MODAL_TABLE_SCROLL_AREA_HEIGHT = "75vh";

/** Fixed band for tbody scroll; pagination sits below */
export const callPlanModalTableScrollAreaSx: SxProps<Theme> = {
  ...tableScrollAreaSx,
  flex: "none",
  minHeight: CALL_PLAN_MODAL_TABLE_SCROLL_AREA_HEIGHT,
  maxHeight: CALL_PLAN_MODAL_TABLE_SCROLL_AREA_HEIGHT,
  overflow: "hidden",
};

export const callPlanModalTableContainerSx: SxProps<Theme> = {
  ...tableContainerSx,
  flex: 1,
  minHeight: 0,
  height: "100%",
  overflow: "auto",
};

export const selectedActivitiesSectionSx: SxProps<Theme> = {
  flexShrink: 0,
  mt: 1.25,
  pt: 1.25,
  borderTop: "1px solid",
  borderColor: "divider",
  display: "flex",
  flexDirection: "column",
  minHeight: 120,
};

export const modalFooterBarSx: SxProps<Theme> = {
  flexShrink: 0,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  pt: 1.5,
};

export const callPlanFieldsSx: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  alignItems: "flex-start",
  flexShrink: 0,
  mb: 1.25,
  pb: 1.5,
  pl: 3,
  pr: 2,
  borderBottom: "1px solid",
  borderColor: "divider",
};

/** Read-only program week; width and top offset align with small `TextField` row */
export const callPlanProgramWeekBlockSx: SxProps<Theme> = {
  width: 140,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

export const callPlanProgramWeekCaptionSx: SxProps<Theme> = {
  display: "block",
  color: "text.secondary",
};

export const callPlanProgramWeekValueSx: SxProps<Theme> = {
  fontWeight: 600,
};

export const callPlanActivitiesHeadingSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 0.75,
  flexShrink: 0,
  fontSize: "0.875rem",
  lineHeight: 1.43,
};
